import { OfflineRfsOrder, RfsAwbInfo } from "../models/OfflineRfs";
import GhaPickupStatusAwb from '../models/GhaPickupStatusAwb';
import PickupOrderGha from "../models/PickupOrderGha";

const PO_SCHEMA: OfflineRfsOrder = {
  rfsNumber: '',
  org: '',
  dst: '',
  airline: -1,
  scheduleDate: '',
  schedule_date: '',
  scheduleTime: '',
  schedule_time: '',
  scheduleArrDate: '',
  schedule_arr_date: '',
  scheduleArrTime: '',
  schedule_arr_time: '',
  arrivalDate: '',
  arrival_date: '',
  arrivalTime: '',
  arrival_time: '',
  truckType: '',
  equipment: '',
  sta: '',
  pickUp: '',
  dropOff: '',
  flight: '',
  pickUpName: '',
  dropOffName: '',
  additional_info: '',
  bill_to: { full_address: '' },
  create_date: '',
  deliver_to: { full_address: '' },
  delivery_company_name: '',
  dispatch_contact: '',
  driver_checkin_time: '',
  driver_contact: '',
  driver_eta: '',
  driver_eta_timestamp: '',
  driver_last_loc: '',
  driver_id: '',
  driver_id_type: '',
  driver_name: '',
  driver_vehichle_registration: '',
  departure_date: '',
  departure_time: '',
  driver_licence: '',
  rfs_number: '',
  endorse_to: { full_address: '' },
  forwarder_company_info: { info: '', address: '', po_prefix: '', contacts: [] },
  forwarder_company_name: '',
  gha_info: { tz: '', info: '', address: '', po_support: false },
  id: -1,
  id_delivery_company: -1,
  id_forwarder: -1,
  id_gha: -1,
  remarks: { remark: '' },
  latest_eta: '',
  //list: [],
  number: '',
  pickup_date: '',
  pickup_from: { full_address: '' },
  pickup_time: '',
  pickup_time_timestamp: '',
  status: '',
  fully_returned: false,
  trucker_info: '',
  driver_signature_key: '',
  org_comment: '',
  dst_comment: '',
  cutoff_date: '',
  cutoff_time: '',
  locked: false,
  sealed: false,
  hazmat: false,
  seal_number: '',
  order_type: '',
  dock_name: '',
  fwd_user_name: '',
  delivered_time: null,
  is_finalised: false,
  is_origin_finalised: false,
  id_pickup: -1,
  id_dropoff: -1,
  truck_type: '',
  allowed_ops: {
    update_date: true,
    update_awb_address: true,
    update_dispatch_driver_details: true,
    driver_checked_in: true,
    update_wh_locations: true,
    set_dock: true,
    update_exception_and_notes: true,
    update_customs_clearance: true,
  },
  droppointname: '',
  pickpointname: '',
  pickinfo: {
    addr1: '',
    addr2: '',
    city: '',
    state: '',
    zip: ''
  },
  dropinfo: {
    addr1: '',
    addr2: '',
    city: '',
    state: '',
    zip: ''
  }
};

const PO_AWB_SCHEMA: GhaPickupStatusAwb ={
  id: -1,
  pieces: 0,
  weight: '',
  remarks: { remarks_text: '' },
  removed: false,
  wh_location: {
    data: [],
    status: 'stored'
  },
  transportation_profile: 'ds',
  ccsf_type: '',
  transportation_number: '',
  shipper_profile: 'Unknown',
  ccsf_pre_screened: false,
  ccsf_approval_number: '',
  unknown_on_pax_flight: false,
  flight_exception : '',
  r4c_form_ver: -1,
  r4c_form_data: '',
  r4c_form_green: false,
  customs_cleared: false,
  payment_confirmed: false,
  clear_awb: false,
  due: false,
  id_awb: -1,
  its: null,
  id_pickup_order: -1,
  actual_scale_weight: '',
  cwt_data: {
    data: [],
    measurement_unit: ''
  },
  info_to_wh: '',
  general_remarks: '',
  iac_name: '',
  ccsf_name: '',
  shipper_name: '',
  iacOkay: false,
  ccsfOkay: false,
  show_on_pod: {
    data: [
      { type: "notes", value: false, label: "Notes" },
      { type: "pictures", value: false, label: "Pictures" },
      { type: "contents_damaged", value: false, label: "Contents Damaged" },
      { type: "kind_of_exception", value: false, label: "Kind of Exception" },
      { type: "type_of_packaging", value: false, label: "Type of Packaging" }
    ]
  },
  interline_transfer_program: {
    carrier: '',
    transfer_programs: []
  },
  customer_error: false
}

const AWB_BASE_INFO: RfsAwbInfo = {
  code: '',
  number: '',
  org: '',
  dst: '',
  pieces: 0,
  version: 0,
  weight: 0
}

const PO_SCHEMA_GHA: PickupOrderGha = {
  additional_info: '',
  bill_to: { full_address: '' },
  create_date: '',
  deliver_to: { full_address: '' },
  delivery_company_name: '',
  order_type: 'rfs',
  dispatch_contact: '',
  driver_checkin_time: '',
  driver_contact: '',
  driver_eta: '',
  driver_eta_timestamp: '',
  driver_last_loc: '',
  driver_name: '',
  driver_vehichle_registration: '',
  rfs_number: '',
  endorse_to: { full_address: '' },
  forwarder_company_info: { info: '', address: '', po_prefix: '', type: '' },
  forwarder_company_name: '',
  gha_info: { tz: '', info: '', address: '', po_support: false },
  id: -1,
  id_delivery_company: -1,
  id_forwarder: -1,
  id_gha: -1,
  latest_eta: '',
  list: [],
  number: '',
  pickup_date: '',
  pickup_from: { full_address: '' },
  pickup_time: '',
  pickup_time_timestamp: '',
  status: '',
  trucker_info: '',
  driver_id: null,
  driver_id_type: null,
  matching_photo: null,
  locked: false,
  sealed: false,
  seal_number: '',
  iac_number: '',
  valid_transportation: false,
  valid_seal_number: true,
  allowed_ops: {
    update_date: true,
    update_awb_address: true,
    update_dispatch_driver_details: true,
    driver_checked_in: true,
    update_wh_locations: true,
    set_dock: true,
    update_exception_and_notes: true,
    update_customs_clearance: true,
  },
  droppointname: '',
  pickpointname: '',
  pickinfo: '',
  dropinfo: '',
  interline_transfer_program: {
    carrier: '',
    transfer_programs: []
  }
};

export {
  PO_SCHEMA,
  PO_AWB_SCHEMA,
  PO_SCHEMA_GHA,
  AWB_BASE_INFO
}
